<a
  mat-icon-button
  (click)="changeShapeVisibility({ source: 'button' }, $event)"
  (mousedown)="$event.stopPropagation()"
  [style.pointer-events]="readOnly ? 'none' : 'auto'"
  [matTooltip]="tooltip"
  tooltipPlacement="left"
>
  <ng-container *ngIf="(visibility$ | async) === 1">
    <mat-icon svgIcon="visible"></mat-icon>
  </ng-container>
  <ng-container *ngIf="(visibility$ | async) === 0.5">
    <mat-icon svgIcon="occluded"></mat-icon>
  </ng-container>
  <ng-container *ngIf="(visibility$ | async) === 0">
    <mat-icon svgIcon="invisible"></mat-icon>
  </ng-container>
</a>
